import { NgModule } from '@angular/core';
import { DataManagementLinksService, BASE_PATH } from 'external-links-generated-api';
import { LinksService } from './services/links.service';

@NgModule({
  providers: [{ provide: BASE_PATH, useExisting: 'partyServiceUrl' }, DataManagementLinksService, LinksService],
})
export class DataManagementLinksModule {}
